/* Events: https://support.maestrooo.com/article/764-javascript-events-exposed-by-the-theme */

/* Global */
window.hidePopovers = function() {
  const popovers = document.querySelectorAll('.quick-buy-drawer');

  popovers.forEach((popover) => {
    popover.removeAttribute('open');
  });
};
/* Event listeners */
/* Event listeners - Product page */
document.addEventListener('DOMContentLoaded', function(event) {
  // Function to attach button listeners
  function attachButtonListeners() {
    const productRecommendations = document.querySelector('product-recommendations');

    if (!productRecommendations) {
      return; // Exit if product recommendations are not found
    }

    const buttons = productRecommendations.querySelectorAll('button[data-origin="recommended_products"]');

    if (buttons.length === 0) {
      setTimeout(attachButtonListeners, 500); // Retry after 500ms
      return; // Exit if no buttons are found
    }

    buttons.forEach(function(button) {
      // Ensure we only attach the listener once
      if (!button.dataset.listenerAttached) {
        button.addEventListener('click', function() {
          // Wait for the quick-buy-drawer to appear
          const checkDrawerInterval = setInterval(() => {
            const openDrawer = document.querySelector('quick-buy-drawer[open]');
            if (openDrawer) {
              clearInterval(checkDrawerInterval); // Stop checking once the drawer is found
              openDrawer.setAttribute('data-origin', 'recommended_products');

              // Listen for clicks on the add-to-cart button inside the open drawer
              const addToCartButton = openDrawer.querySelector('button[type="submit"]');
              if (addToCartButton) {
                addToCartButton.addEventListener('click', function() {
                  // Wait for 1.5 seconds before hiding the buttons and showing countdown
                  setTimeout(function() {
                    hideButtonsAndStartCountdown(openDrawer);
                  }, 1500); // Wait for 1.5 seconds before executing success logic
                });
              }
            }
          }, 100); // Check every 100ms for the drawer to appear
        });

        button.dataset.listenerAttached = 'true';
      }
    });
  }

  // Function to hide buttons and start countdown
  function hideButtonsAndStartCountdown(drawer) {
    const buyButtons = drawer.querySelectorAll('.buy-buttons');

    // Hide the buttons
    buyButtons.forEach(button => {
      button.style.display = 'none'; // Make invisible
    });

    // Start the 3-second countdown
    let countdown = 3;
    const countdownDisplay = document.createElement('div');
    countdownDisplay.classList.add('countdown-display');
    countdownDisplay.style.textAlign = 'center';
    countdownDisplay.style.fontSize = '16px';
    countdownDisplay.style.marginTop = '10px';
    drawer.appendChild(countdownDisplay);

    countdownDisplay.innerHTML = `Vent venligst...`; // Display countdown text to the user
    
    const countdownInterval = setInterval(() => {
      if (countdown > 0) {
        countdownDisplay.innerHTML = `Lukker om ${countdown}...`; // Display countdown text to the user
        countdown--;
      } else {
        clearInterval(countdownInterval);
        drawer.removeChild(countdownDisplay); // Remove the countdown text
        window.hidePopovers(); // Close the popover and reset buttons
      }
    }, 1000);
  }

  // Initial call to attach listeners
  attachButtonListeners();
});

